import * as S from "./styled"

import React from 'react';

const NoSearch = () => {
    return <S.Wrapper>Sem Resultados</S.Wrapper>
}

export default NoSearch;
